module.exports = __webpack_public_path__ + "img/amtf.d8b12f62.jpg";